// @core/api/endpoints/team/list_team_members.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamMembersResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List team members
 * Returns all members of a team with their roles and membership details. Supports pagination and filtering.
 */
export async function ListTeamMembers(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamMembersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/members`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamMembersResponse>(requestPath, { ...requestOptions, params });
}
